class Source {
  constructor() {
    this.embeddable = true
    this.inputs = {
      MAIN: "TV",
      VOD: "TV",
      HLS: "TV",
      MULTICAST: "TV",
      RF: "TV",
      HDMI1: "HDMI",
      HDMI2: "HDMI-2",
      HDMI3: "HDMI-3"
    }
  }
  _init = async () => {
    const current = await this.get().catch(err => _$.error(err))
    if (current !== this.inputs.MAIN) await this.set(this.inputs.MAIN).catch(err => _$.error(err))

    return true
  }

  get = async () => {
    const source = tizen.tvwindow.getSource()
    if (source.number <= 1) return `${source.type}`
    else return `${source.type}-${source.number}`
  }
  set = async source => {
    if (!source) return false
    source = source.split("-")

    let promise = await _$.progress.create()
    let type = source[0],
      number = source[1] || 1

    /* Library Code */
    try {
      const error_callback = payload => promise.reject(payload.message)
      const changed_callback = source => {
        if (source.number <= 1) source = source.type
        else source = `${source.type}-${source.number}`

        promise.resolve()
        _$.handler.emit("source_event", source)
      }
      const success_callback = sources => {
        let res = 0
        for (var i = 0; i < sources.connected.length; i++) {
          if (sources.connected[i].type == type && sources.connected[i].number == number) {
            tizen.tvwindow.setSource(sources.connected[i], changed_callback, error_callback)
            res = 1
            break
          }
        }
        if (!res) promise.reject()
      }

      tizen.systeminfo.getPropertyValue("VIDEOSOURCE", success_callback, error_callback)
    } catch (error) {
      promise.reject(error.message)
    }
    /* Library Code */

    return promise.done
  }
}

export default Source
